export default __webpack_public_path__ + "static/media/hectorfeliz.0f9f2cac.vcf";